<template>
    <div class="filter-options-wrapper">
        <ul class="area-wrapper" v-for="areaData in data" :key="areaData.label">
            <div class="area-name">{{areaData.label}}</div>
            <li
                v-for="item in areaData.children"
                :key="item.id"
                class="option"
                :class="{'is-selected': isSelectedClass(item),'is-disabled': item.disabled}"
                @click="handleClickOption(item)"
            >
                <el-checkbox
                    v-if="levelSelect.multiple"
                    :key="item.id"
                    :value="judgeSelected(item)"
                    @change="(val) => handleCheck(val, item)"
                ></el-checkbox>
                <i v-else class="checked" :class="{'el-icon-check': item.checked }"></i>
                <level-label :data="item"></level-label>
            </li>
        </ul>
        <div class="placeholder" v-if="!data.length">无匹配数据</div>
    </div>
</template>
<script>
import { deepClone } from '@lsfe/tools';
import LevelLabel from './OptionsWrapper/LevelLabel';

export default {
    components: {
        LevelLabel
    },
    inject: ['levelSelect'],
    data() {
        return {
            data: []
        };
    },
    methods: {
        isSelectedClass(data) {
            const { store } = this.levelSelect;
            if (!data.children) {
                return !!store.selectedValueMap[data.id];
            }
            return data._selectedCount && data._selectedCount !== 0;
        },
        judgeSelected(data) {
            const { store } = this.levelSelect;
            if (!data.children) {
                return !!store.selectedValueMap[data.id];
            }
            return data._selectedCount === data._count;
        },
        handleClickOption(item) {
            const { store } = this.levelSelect;
            // 选择门店
            if (this.levelSelect.multiple) {
                return;
            }
            store.handleSelected(item);
            this.levelSelect.emitChange();
            // 切换父级菜单
            return store.handleChangeActiveOpt(item, store.levelLength);
        },
        handleCheck(val, item) {
            const {maxSelectedCount, store} = this.levelSelect;
            if (val && !item.children && store.selectedValue.length >= maxSelectedCount) {
                // 选择数量限制
                return this.$message.warning(`选择失败，超出选择数量上限：${maxSelectedCount}`);
            }
            this.levelSelect.store.handleCheck(val, item);
            this.levelSelect.emitChange();
            this.levelSelect.emitCheck(val, deepClone(item));
        },
        filter(val) {
            this.data = this.levelSelect.store.handleFilter(val, this.levelSelect.maxFilterLength || 100);
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../styles/common/var.scss';

.filter-options-wrapper {
    position: relative;
    min-width: 350px;
    height: 210px;
    overflow: auto;
    .placeholder {
        width: 100px;
        height: 14px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        text-align: center;
    }
    .area-wrapper {
        padding: 0 10px;
        font-size: 13px;
        & + .level-wrapper {
            border-left: 1px solid #dcdfe6;
        }
        .area-name {
            font-size: 10px;
            color: #909399;
            padding: 5px 0;
        }
        .option {
            cursor: pointer;
            padding: 2px 0;
            box-sizing: border-box;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            &.is-active {
                background-color: #f5f7fa;
                font-weight: 500;
            }
            &.is-selected {
                color: $--color-primary;
            }
            &:hover {
                background-color: #f5f7fa;
                overflow: visible;
                .label {
                    background-color: #f5f7fa;
                }
            }
            .checked {
                display: inline-block;
            }
            .count {
                font-size: 0;
                span {
                    font-size: 13px;
                }
            }
        }
    }
}
</style>
